import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import Home from './components/Home';
import AboutPage from './components/AboutPage';
import Products from './components/Products';
import GroceryApp from './components/GroceryApp';
import ProductRecommendation from './components/ProductRecommendation';
import CropDiseaseDetection from './components/CropDiseaseDetection';
import IndustrySolutionPage from './components/IndustrySolutionPage';
import FractoStudio from './components/FractoStudio';
import Security from './components/Security';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Cookie from './components/Cookie';
import Abuse from './components/Abuse';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<Products />} />
            <Route path="/optical-crm" element={<Products />} />
            <Route path="/grocery-app" element={<GroceryApp />} />
            <Route path="/recommendation-engine" element={<ProductRecommendation />} />
            <Route path="/crop-disease-detection" element={<CropDiseaseDetection />} />
            <Route path="/industry-solutions/:solutionSlug" element={<IndustrySolutionPage />} />
            <Route path="/online-video-editor" element={<FractoStudio />} />
            <Route path="/security" element={<Security />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<Cookie />} />
            <Route path="/abuse" element={<Abuse />} />
          </Routes>
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;

